import {Vue} from "ui.vue";

export default {
	name: "ElementList",
	props: {
		_items: {
			type: Array,
			default: []
		},
		_ajaxParams: {
			type: Object,
			default: () => {
				return {
					parameters: "",
					rewrite: {},
					filter: {}
				};
			}
		},
		_pagination: {
			type: [Object, false],
			default: false
		},
		_locPrefix: {
			type: String,
			default: "CC_ELEMENT_LIST_"
		},
		preloading: {
			type: Boolean,
			default: false
		},
		stepPageSize: {
			type: Number,
			default: 0
		}
	},
	template: '<div><slot v-bind:items="items" v-bind:pagination="pagination"></slot></div>',
	data: () => {
		return {
			loading: false,
			items: false,
			nextItems: [],
			shownItems: 0,
			load: {
				start: false,
				pageNumber: 1,
				isMoreLink: false
			},
			ajaxParams: {
				parameters: "",
				rewrite: {},
				filter: {}
			},
			pagination: false,
			locPrefix: "CC_ELEMENT_LIST_",
		};
	},
	created() {
		this.ajaxParams = this._ajaxParams;
		this.pagination = this._pagination;
		this.items = this._items;
		this.shownItems = this.items.length;

		BX.addCustomEvent('CatalogSectionDefault:sort', this.onSort);
		BX.addCustomEvent('CatalogSectionDefault:filter', this.onFilter);

		this.request();
	},
	methods: {
		getLoading() {
			return this.loading;
		},
		detailPageUrl(url) {
			return null === url || !url ? "javascript:void(0)" : url;
		},
		changePage(data) {
			this.load.pageNumber = data.hasOwnProperty("pageNumber") ? data["pageNumber"] : 1;
			this.load.isMoreLink = data.hasOwnProperty("isMoreLink") ? data["isMoreLink"] : false;

			this.refresh();
		},
		nextPage() {
			this.load.isMoreLink = true;
			this.showNextItems();
			this.request();
		},
		onSort(sort, order) {
			if (!this.ajaxParams.hasOwnProperty('rewrite')) {
				this.ajaxParams.rewrite = {};
			}

			this.ajaxParams.rewrite.SORT_BY1 = sort;
			this.ajaxParams.rewrite.SORT_ORDER1 = order;

			this.load.pageNumber = 1;
			this.load.isMoreLink = false;

			this.refresh();
		},
		onFilter(filter) {
			if (!this.ajaxParams.hasOwnProperty('filter')) {
				this.ajaxParams.filter = {};
			}

			this.ajaxParams.filter = Object.assign({}, this.ajaxParams.filter, filter);

			this.load.pageNumber = 1;
			this.load.isMoreLink = false;

			this.refresh();
		},
		showNextItems() {
			if (this.nextItems.length == 0) {
				return;
			}

			let stepPageSize = this.stepPageSize > 0 ? this.stepPageSize : this.pagination.pageSize;//по сколько показывать
			let nextPageItems = this.nextItems.slice(0, stepPageSize);// первые stepPageSize элементов из начала очереди
			this.nextItems.splice(0, stepPageSize);//удалить stepPageSize элементов из начала очереди
			this.items = this.items.concat(...nextPageItems);
			this.shownItems = this.items.length;
			this.$emit("loaded", {pagination: this.pagination, items: nextPageItems, shownItems: this.shownItems});
		},
		refresh() {
			if (this.preloading && this.load.isMoreLink) {
				this.showNextItems();
				this.request();

				return;
			}

			if (this.loading || !this.pagination) {
				return;
			}

			this.loading = true;

			this.ajaxParams["nav"] = {
				param: this.pagination.pageParam,
				value: this.load.pageNumber
			};

			this.load.start = true;

			this.$request
				.setModeModule()
				.setAction("citrus:component.component.execute")
				.setData(this.ajaxParams)
				.send()
				.then((response) => {
					this.loading = false;

					if (this.load.isMoreLink) {
						this.items = this.items.concat(response.items);
					} else {
						this.items = response.items;
						//this.scrollToElement();
					}

					this.$set(this, "pagination", response.pagination);

					this.load.start = false;
					BX.onCustomEvent("Citrus.Component.Element.List:ajaxLoadDataCompleted", [response.items]);

					this.$emit("loaded", {pagination: response.pagination, items: response.items, shownItems: this.shownItems});
				}, (error) => {
					console.error(error);
					this.loading = false;
					this.load.start = false;
				});
		},
		request() {
			if (!this.preloading || this.loading || !this.pagination) {
				return;
			}

			if (this.load.pageNumber >= this.pagination.pagesCount) {
				return;
			}

			this.load.pageNumber++;
			this.load.isMoreLink = true;

			this.ajaxParams["nav"] = {
				param: this.pagination.pageParam,
				value: this.load.pageNumber
			};

			this.loading = true;
			this.load.start = true;
			this.$request
				.setModeModule()
				.setAction("citrus:component.component.execute")
				.setData(this.ajaxParams)
				.send()
				.then((response) => {
					this.loading = false;
					this.nextItems = this.nextItems.concat(response.items);
					this.$set(this, "pagination", response.pagination);

					let stepPageSize = this.stepPageSize > 0 ? this.stepPageSize : this.pagination.pageSize;//по сколько показывать
					let nextPageItems = this.nextItems.slice(0, stepPageSize);// первые stepPageSize элементов из начала очереди
					this.$emit("next-step-size", {items: nextPageItems});

					this.load.start = false;
				}, (error) => {
					console.error(error);
					this.loading = false;
					this.load.start = false;
				});
		},
		async scrollToElement() {
			let slide = this.$el;
			if (!slide) {
				return;
			}

			let top = window.scrollY + slide.getBoundingClientRect().y;
			window.scrollTo({
				top: top,
				behavior: 'smooth'
			});
		},
		show(item) {
			item.active = !item.active;
		}
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases(this.locPrefix);
		}
	}
};
